// Module
var code = "<mb-icon ng-click=\"ctrl.openMessages($event)\" size=\"16\" style=\"padding:4px\">notifications</mb-icon>";
// Exports
var _module_exports =code;;
var path = '/viraweb123/vw-dashboard/src/modules/account/components/messages.html';
window.angular.module('mblowfishApp').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
export default path;